import React, { useEffect, useState } from 'react';
import axios from 'axios';
import OwnerSidebar from '../components/Sidebar/OwnerSidebar'; // ✅ FIX NAME

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Legend
} from 'recharts';

import {
  FaUsers,
  FaBuilding,
  FaUserFriends,
  FaHome,
  FaDoorClosed,
  FaTools,
} from 'react-icons/fa';

import './Owner.css';

const COLORS = ['#0088FE', '#00C49F', '#FF8042'];

const DashboardHome = () => {

  const [barData, setBarData] = useState([]);
  const [pieData, setPieData] = useState([]);
  const [stats, setStats] = useState({
    totalTenants: 0,
    apartmentUnits: 0,
    totalPeople: 0,
    availableUnits: 0,
    unavailableUnits: 0,
    underMaintenanceUnits: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const tenantsResponse = await axios.get('https://ikaze-thouse-backend.vercel.app/api/v1/tenants/getAll');
        const unitsResponse = await axios.get('https://ikaze-thouse-backend.vercel.app/api/v1/appartmentUnits/getAll');

        const tenants = tenantsResponse.data.data || [];
        const apartmentUnitsList = unitsResponse.data.data || [];

        const totalTenants = tenants.length;
        const apartmentUnits = apartmentUnitsList.length;

        const availableUnits = apartmentUnitsList.filter(unit => unit.status === 'Available').length;
        const underMaintenanceUnits = apartmentUnitsList.filter(unit => unit.status === 'Maintenance').length;
        const occupiedUnits = apartmentUnits - availableUnits - underMaintenanceUnits;

        // Group Rent
        const grouped = {};
        tenants.forEach(tenant => {
          const unitName = tenant.appartment_unite;
          if (!grouped[unitName]) grouped[unitName] = { name: unitName, Rent: 0 };
          grouped[unitName].Rent += Number(tenant.rent) || 0;
        });

        const totalPeople = tenants.reduce((total, tenant) => {
          return total +
            (Number(tenant.number_adults) || 0) +
            (Number(tenant.number_child) || 0);
        }, 0);

        setBarData(Object.values(grouped));
        setPieData([
          { name: 'Occupied', value: occupiedUnits },
          { name: 'Available', value: availableUnits },
          { name: 'Maintenance', value: underMaintenanceUnits },
        ]);

        setStats({
          totalTenants,
          apartmentUnits,
          totalPeople,
          availableUnits,
          unavailableUnits: occupiedUnits,
          underMaintenanceUnits,
        });

      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <h2 style={{ padding: "30px" }}>Loading dashboard...</h2>;
  }

  const cardInfo = [
    { title: 'Total Tenants', value: stats.totalTenants, icon: <FaUsers size={28} /> },
    { title: 'Total Apartment Units', value: stats.apartmentUnits, icon: <FaBuilding size={28} /> },
    { title: 'Total People', value: stats.totalPeople, icon: <FaUserFriends size={28} /> },
    { title: 'Available Units', value: stats.availableUnits, icon: <FaHome size={28} /> },
    { title: 'Occupied Units', value: stats.unavailableUnits, icon: <FaDoorClosed size={28} /> },
    { title: 'Under Maintenance', value: stats.underMaintenanceUnits, icon: <FaTools size={28} /> },
  ];

  return (
    <div style={{ display: "flex" }}>

      {/* ✅ Sidebar */}
      <OwnerSidebar />

      {/* ✅ Main Content */}
      <div className="dashboard-home" style={{ flex: 1, padding: "30px" }}>

        <h2>🏢 Owner Dashboard Overview</h2>

        {/* Cards */}
        <div className="dashboard-cards">
          {cardInfo.map((card, index) => (
            <div key={index} className="dashboard-card">
              <div className="icon-wrapper">{card.icon}</div>
              <h3>{card.title}</h3>
              <p>{card.value}</p>
            </div>
          ))}
        </div>

        {/* Charts */}
        <div className="charts-section">

          {/* Bar Chart */}
          <div className="chart-box">
            <h4>Rent per Apartment Unit</h4>
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={barData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" angle={-40} textAnchor="end" height={60} />
                <YAxis />
                <Tooltip />
                <Bar dataKey="Rent" fill="#8884d8" radius={[5, 5, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>

          {/* Pie Chart */}
          <div className="chart-box">
            <h4>Unit Status Distribution</h4>
            <ResponsiveContainer width="100%" height={300}>
              <PieChart>
                <Pie
                  data={pieData}
                  outerRadius={100}
                  dataKey="value"
                  label={({ name, percent }) =>
                    `${name}: ${(percent * 100).toFixed(0)}%`
                  }
                >
                  {pieData.map((_, index) => (
                    <Cell key={index} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Pie>
                <Legend />
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          </div>

        </div>
      </div>
    </div>
  );
};

export default DashboardHome;